import React from "react";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import Home from "./pages/Home";
import UserManagement from "./pages/UserManagement";
import ProjectManagement from "./pages/ProjectManagement";
import QRCodeGenerator from "./pages/QRCodeGenerator";
import LogManagement from "./pages/LogManagement";
import SessionManagement from "./pages/SessionManagement";
import Login from "./pages/Login";
import Main from "./components/layout/Main";
import SystemUserManagement from "./pages/SystemUserManagement";
import ProtectedRoute from "./components/ProtectedRoute";
import ForgotPassword from "./pages/ForgotPassword";
import "antd/dist/antd.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";

function App() {
  return (
    <div className="App">
      <HashRouter>
        <Switch>

          <Route exact path="/login" component={Login} />
          <Route exact path="/forgot-password" component={ForgotPassword} />

          <Main>
            <Switch>
              <ProtectedRoute exact path="/dashboard" component={Home} />
              <ProtectedRoute exact path="/usermanagement" component={UserManagement} />
              <ProtectedRoute exact path="/projectmanagement" component={ProjectManagement} />
              <ProtectedRoute exact path="/qrcode" component={QRCodeGenerator} />
              <ProtectedRoute exact path="/sessionmanagement" component={SessionManagement} />
              <ProtectedRoute exact path="/logmanagement" component={LogManagement} />
              <ProtectedRoute exact path="/systemusermanagement" component={SystemUserManagement} />

              <Redirect from="/" to="/dashboard" />
            </Switch>
          </Main>

        </Switch>
      </HashRouter>
    </div>
  );
}

export default App;